var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SecondaryNavbarComponent',{attrs:{"nameAndRoute":_vm.nameAndRoute,"routeName":_vm.routeName}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }